import { getOneTimeJWTToken } from '@/services/Reports/reports.services';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

export enum JWTStatuses {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}
interface OneTimeJWTState {
  jwtToken: string | undefined;
  status: JWTStatuses;
  error: string | null;
}

const initialState: OneTimeJWTState = {
  jwtToken: '',
  status: JWTStatuses.IDLE,
  error: null,
};

export const fetchOneTimeJWTToken = createAsyncThunk('oneTimeJWT/fetch', async () => {
  const token = await getOneTimeJWTToken();
  return token;
});

const oneTimeJWTSlice = createSlice({
  name: 'oneTimeJWT',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOneTimeJWTToken.pending, (state) => {
        state.status = JWTStatuses.LOADING;
      })
      .addCase(
        fetchOneTimeJWTToken.fulfilled,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = JWTStatuses.SUCCEEDED;
          state.jwtToken = action.payload;
        },
      )
      .addCase(fetchOneTimeJWTToken.rejected, (state, action) => {
        state.status = JWTStatuses.FAILED;
        state.error = action.error.message || null;
      });
  },
});

export default oneTimeJWTSlice.reducer;
